export default __webpack_public_path__ + "static/media/13-pepe-ganga.acc034fa.jpg";